import './src/main.css'
import Decoration10 from './src/main.vue'

export default function (Vue) {
  Vue.component(Decoration10.name, Decoration10)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/decoration10/index.js